// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"styles_linkWrapper__EX67K"};